/* eslint-disable camelcase */
import React from 'react';
import { Disqus, CommentCount } from 'gatsby-plugin-disqus';

const DisqusWrapper = (blog_headline, id, useCase) => {
  const disqusConfig = {
    url: `https://www.digitalocean.com/blog/${id}`,
    identifier: `${id}`,
    title: `${blog_headline[0].text}`,
  };

  const comments = (
    <div className="disqus">
      <Disqus config={disqusConfig} />
    </div>
  );

  const commentCount = (
    <a href="#disqus_thread" className="comment-count">
      <CommentCount config={disqusConfig} placeholder="..." />
    </a>
  );

  if (useCase === 'comments') {
    return comments;
  }

  if (useCase === 'commentCount') {
    return commentCount;
  }

  return null;
};

export default DisqusWrapper;
